import { t } from "@/i18n-js/instance";
import { Form } from "@/react/components/shared/uikit/Form";
import { LocationInput } from "@/react/components/shared/uikit/Form/LocationInput";
import { Modal } from "@/react/components/shared/uikit/ModalV2";
import { Typography } from "@/react/components/shared/uikit/Typography";

interface BodyProps {
  hasLocation: boolean;
}

const i18nRoot = "filters.near_me";

export const Body = ({ hasLocation }: BodyProps) => (
  <Modal.Body>
    <div className="flex flex-col gap-y-2">
      <Typography.BodyMd color="text-default">
        {hasLocation
          ? t(`${i18nRoot}.with_location.description`)
          : t(`${i18nRoot}.no_location.description`)}
      </Typography.BodyMd>
      <Form.Item
        name="location"
        label={t(`${i18nRoot}.label`)}
        hideBorder
        hideDescription
      >
        <LocationInput
          name="location"
          locationTypesToSearch={["place", "locality", "neighborhood"]}
          className="mt-2"
          inputPlaceholder={t(`${i18nRoot}.input_placeholder`)}
        />
      </Form.Item>
    </div>
  </Modal.Body>
);
